<template>
  <v-container>
    <h1>
      <v-icon v-if="!isEdited" class="teams-icon" color="lighten-1" medium
        >mdi-account-multiple-plus</v-icon
      ><v-icon v-else class="teams-icon" color="lighten-1" medium
        >mdi-pencil</v-icon
      >
      <span v-if="!isEdited">Add Bus Location</span>
      <span v-else>Edit Bus Location </span>
    </h1>

    <formWrapper :validator="$v.form">
      <form @submit.prevent="handleSave" class="form-box">
        <v-row>
          <v-col class="py-2" cols="12">
            <form-group name="start_point" :attribute="`fields.start_point`">
              <template slot-scope="{ attrs, listeners }">
                <v-text-field
                  v-bind="attrs"
                  v-on="listeners"
                  regular
                  v-model.trim="form.start_point"
                  type="text"
                >
                </v-text-field>
              </template>
            </form-group>
          </v-col>
          <v-col sm="6" cols="12">
            <form-group name="bus_no" :attribute="`fields.bus_no`">
              <template slot-scope="{ attrs, listeners }">
                <v-text-field
                  v-bind="attrs"
                  v-on="listeners"
                  regular
                  v-model.trim="form.bus_no"
                  type="text"
                >
                </v-text-field>
              </template>
            </form-group>
          </v-col>
          <v-col sm="6" cols="12">
            <section class="increment-label">
              <span>Capacity</span>
              <number-input
                center
                v-model="form.capacity"
                :min="0"
                controls
              ></number-input>
            </section>
          </v-col>
          <v-col class="py-2 mx-auto" cols="12" sm="6">
            <form-group name="longitude" :attribute="`fields.longitude`">
              <template slot-scope="{ attrs, listeners }">
                <v-text-field
                  v-bind="attrs"
                  v-on="listeners"
                  regular
                  v-model.trim="form.longitude"
                  type="text"
                >
                </v-text-field>
              </template>
            </form-group>
          </v-col>
          <v-col class="py-2 mx-auto" cols="12" sm="6">
            <form-group name="latitude" :attribute="`fields.latitude`">
              <template slot-scope="{ attrs, listeners }">
                <v-text-field
                  v-bind="attrs"
                  v-on="listeners"
                  regular
                  v-model.trim="form.latitude"
                  type="text"
                >
                </v-text-field>
              </template>
            </form-group>
          </v-col>

          <v-col cols="12">
            <v-btn
              class="success text-capitalize"
              large
              type="submit"
              width="30%"
              :disabled="$v.form.$invalid"
              ><span>Save</span>
            </v-btn>
          </v-col>
        </v-row>
      </form>
    </formWrapper>
  </v-container>
</template>

<script>
import { StoreData, ShowData, UpdateData } from "@/helpers/apiMethods";
import {
  required,
  decimal,
  minValue,
  maxValue,
  maxLength
} from "vuelidate/lib/validators";
export default {
  data() {
    return {
      form: {
        start_point: "",
        bus_no: "",
        capacity: "",
        longitude: "",
        latitude: ""
      },
      isEdited: false,
      loadingData: false
    };
  },
  created() {
    this.editCreateBoolean();
  },
  methods: {
    handleSave() {
      if (!this.isEdited) {
        this.createBusLocation();
      } else {
        this.editBusLocation();
      }
    },
    editCreateBoolean() {
      if (this.$route.params.id) {
        this.isEdited = true;
      } else {
        this.isEdited = false;
      }
    },
    showData(id) {
      ShowData({
        reqName: `bus-locations`,
        id: id
      })
        .then(res => {
          const { bus_location } = res.data;
          this.form = bus_location;
        })
        .catch(() => {});
    },
    createBusLocation() {
      StoreData({
        reqName: `bus-locations`,
        data: this.form
      })
        .then(() => {
          this.$router.push("/bus-locations");
        })
        .catch(() => {})
        .finally(() => {});
    },
    editBusLocation() {
      const {
        start_point,
        capacity,
        bus_no,
        latitude,
        longitude,
        auto_applied
      } = this.form;
      UpdateData({
        reqName: `bus-locations`,
        data: {
          start_point,
          capacity,
          bus_no,
          latitude,
          longitude,
          auto_applied,
          _method: "put"
        },
        id: this.$route.params.id
      })
        .then(res => {
          this.isEdited = false;
          this.$router.push("/bus-locations");
          console.log(res);

          this.reset();
        })
        .catch(() => {})
        .finally(() => {});
    },
    reset() {
      this.$v.form.$reset();
      this.$store.dispatch("ClearServerErrors");
    }
  },
  watch: {
    $route: {
      handler(route) {
        if (route.name === "busLocationEdit") {
          this.$nextTick(() => {
            this.showData(route.params.id);
          });
        }
      },
      immediate: true,
      deep: true
    }
  },
  validations: {
    form: {
      start_point: {
        required,
        maxLength: maxLength(190)
      },
      capacity: {
        required,
        minValue: minValue(1),
        maxValue: maxValue(1000)
      },
      bus_no: {
        required,
        maxLength: maxLength(190)
      },
      latitude: {
        decimal,
        minValue: minValue(-90),
        maxValue: maxValue(90)
      },
      longitude: {
        decimal,
        minValue: minValue(-180),
        maxValue: maxValue(180)
      }
    }
  }
};
</script>
